<template>
  <BaseDrawer
    drawerName="admin"
    :miniVariant="false"
    v-if="userLoaded"
  />
</template>

<script>
import { mapActions } from 'vuex'

import BaseDrawer from '@/components/base/BaseDrawer'

export default {
  name: 'AdminDrawer',

  components: {
    BaseDrawer
  },

  data: () => ({
    userLoaded: false
  }),
  async created () {
    await this.requestUserInfo()
    await this.requestAllOrganizations()
    this.userLoaded = true
  },
  methods: {
    ...mapActions(['requestUserInfo', 'requestAllOrganizations'])
  }
}
</script>

<style lang="sass" scoped>

</style>
